import { http } from "./http";

const ENDPOINTS = {
  ACCOUNTS: "/account-selections/",
  ACCOUNT: (id) => `/account-selections/${id}/`,
  ACCOUNTS_BY_PHASE: (phaseId) => `/account-selections?phase=${phaseId}/`,
};

export const accountAPI = {
  getAll: () => http.get(ENDPOINTS.ACCOUNTS),
  getById: (id) => http.get(ENDPOINTS.ACCOUNT(id)),
  create: (accountData) => http.post(ENDPOINTS.ACCOUNTS, accountData),
  update: (id, accountData) => http.patch(ENDPOINTS.ACCOUNT(id), accountData),
  delete: (id) => http.delete(ENDPOINTS.ACCOUNT(id)),
  getByPhase: (phaseId) => http.get(ENDPOINTS.ACCOUNTS_BY_PHASE(phaseId)),
};